import { IModule } from "./IModule";

export abstract class ModuleFlowExecutor<T extends IModule<R>, R = void> {
    public abstract execute(module: T): Promise<R>;
}